export default "__VITE_ASSET__mavSsng3__";